export default (value) => {
  switch (value) {
    case 'Kilometers':
      return 'km';
    case 'Mijlen':
      return 'm';
    default:
      return value;
  }
};
